import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useAuth } from "../../contexts/auth/Context";
import { useToast } from "../../contexts/toast/Context";
import {
  getClientAppConfigRequest,
  updateClientAppConfigRequest,
} from "../requests/gym";
import { CACHE_TIMES } from "../../query/options";

const CLIENT_APP_CONFIG_QUERY_KEY = ["gym", "clientAppConfig"] as const;

export const useClientAppConfig = () => {
  const { token } = useAuth();
  const { showToast } = useToast();
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: CLIENT_APP_CONFIG_QUERY_KEY,
    queryFn: () => getClientAppConfigRequest(token!),
    enabled: !!token,
    ...CACHE_TIMES.MASTER_DATA,
  });

  const mutation = useMutation({
    mutationFn: (autoInviteOnCreate: boolean) =>
      updateClientAppConfigRequest({ autoInviteOnCreate }, token!),
    onSuccess: (data) => {
      queryClient.setQueryData(CLIENT_APP_CONFIG_QUERY_KEY, data);
      showToast(
        data.autoInviteOnCreate
          ? "Invitación automática activada"
          : "Invitación automática desactivada",
        "success",
      );
    },
    onError: (err: Error) => {
      showToast(err.message ?? "Error al guardar la configuración", "error");
    },
  });

  return {
    autoInviteOnCreate: query.data?.autoInviteOnCreate ?? false,
    isLoading: query.isLoading,
    setAutoInviteOnCreate: mutation.mutate,
    isUpdating: mutation.isPending,
  };
};
